import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/lib/data";

const Services = () => (
  <>
    <section className="relative pt-40 pb-20 md:pt-52 border-b border-white/5" data-testid="services-hero">
      <div className="max-w-[1480px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="font-mono-tech text-[11px] tracking-[0.22em] uppercase text-[var(--gold)] mb-6">
            <span className="text-white/35 mr-3">S / 00</span>Services
          </div>
          <h1 className="font-display text-6xl md:text-[7.5vw] leading-[0.92] tracking-[-0.03em] text-white max-w-5xl">
            Six disciplines.<br />
            <span className="font-serif-display text-[var(--gold)]">One</span> visual language.
          </h1>
          <p className="mt-10 max-w-2xl text-white/65 text-lg leading-relaxed">
            Whether you found us through a wedding planner, a brand strategist, or a friend with very good taste —
            here is exactly what we do, and what is included.
          </p>
        </Reveal>
      </div>
    </section>

    <div className="divide-y divide-white/5">
      {SERVICES.map((s, idx) => (
        <section
          id={s.slug}
          key={s.slug}
          data-testid={`service-section-${s.slug}`}
          className="relative py-20 md:py-32 scroll-mt-24"
        >
          <div className="max-w-[1480px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
            <Reveal className={`md:col-span-6 ${idx % 2 ? "md:order-2" : ""}`}>
              <div className="relative aspect-[4/5] overflow-hidden bg-[#0a0a0a]">
                <img src={s.hero} alt={s.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                <div className="absolute top-4 left-4 font-mono-tech text-[10px] tracking-[0.22em] uppercase text-white bg-black/55 px-3 py-1 border border-white/10">
                  {s.tag} · {s.name}
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.1} className={`md:col-span-6 ${idx % 2 ? "md:order-1" : ""}`}>
              <div className="font-mono-tech text-[11px] tracking-[0.22em] uppercase text-[var(--cyan)] mb-4">
                {s.slug === "partnership" ? "Flagship Program" : "Custom Production"}
              </div>
              <h2 className="font-display text-5xl md:text-6xl tracking-tight text-white leading-[1.0]">
                {s.name}
              </h2>
              <p className="mt-4 font-serif-display text-2xl text-[var(--gold)]">{s.short}</p>
              <p className="mt-6 text-white/70 leading-relaxed text-lg max-w-xl">{s.description}</p>

              <ul className="mt-10 space-y-3 max-w-md">
                {s.deliverables.map((d) => (
                  <li key={d} className="flex items-start gap-3 text-white/80">
                    <Check size={16} className="text-[var(--gold)] mt-1 shrink-0" />
                    <span>{d}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-10 flex flex-wrap gap-3">
                <Link to="/contact" className="btn-gold" data-testid={`service-cta-${s.slug}`}>
                  <span>Inquire</span><ArrowUpRight size={14} />
                </Link>
                <Link to="/portfolio" className="btn-ghost-light">See work</Link>
              </div>
            </Reveal>
          </div>
        </section>
      ))}
    </div>
  </>
);

export default Services;
